import produce from 'immer';

// TYPES
import { Types, ExcluirUnidade } from './types';
import { ReducerAction } from '../../../../../types';

export const INITIAL_STATE: ExcluirUnidade = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ExcluirUnidade {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_UNIDADE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EXCLUIR_UNIDADE_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.EXCLUIR_UNIDADE_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.EXCLUIR_UNIDADE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
